// import React, { useContext } from "react";
// import css from "../Modulecss/Home.module.css";
// import { Link } from "react-router-dom";
// import Header from "../Components/Header";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { colors } from "@mui/material";

// export default function RunningCard({ runnig, winnAmount, game_type }) {
//   const user = localStorage.getItem("userId");
//   // console.log(user,"running")

//   // language
//   const translations = {
//     hi: {
//       view: "देखे",
//       prize: "इनाम",
//       entry: "प्रवेश शुल्क",
//     },
//     en: {
//       view: "view",
//       entry: "Entry Fee ",
//       prize: "Winning Prize",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   // change theme
//   const theme  = localStorage.getItem('theme')

//   const styles = {
//     color: theme === "light" ? "black" : "black",
//   };

//   return (
//     <>
//       <div
//         className={`${css.betCard} mt-1 battle_card_main card_bottom_border`}
//       >
//         <div className="d-flex">
//           <span
//             className={`${css.betCardTitle} pl-3 d-flex align-items-center headings`}
//             style={{ color: "#000" }}
//           >
//             Playing For
//           </span>
//           <span
//             className={`${css.betCardTitle} pl-3 d-flex align-items-center headings`}
//             style={{ marginLeft: "6px", color: "rgb(87 21 90)" }}
//           >
//             {runnig.Created_by.Name.length > 5 ? `${runnig.Created_by.Name.slice(0, 5)}...` : runnig.Created_by.Name}

//           </span>
//           <span
//             className={`${css.betCardTitle} pl-3 d-flex align-items-center headings`}
//             style={{ marginLeft: "-32px", color: "rgb(87 21 90)" }}
//           >
//             &
//           </span>
//           <span
//             className={`${css.betCardTitle} pl-3 d-flex align-items-center headings `}
//             style={{ marginLeft: "-70px",color: "#000" }}
//           >


//              {runnig.Accepetd_By.Name.length > 5 ? `${runnig.Accepetd_By.Name.slice(0, 5)}....` : runnig.Accepetd_By.Name}
//           </span>

//           <div
//             className={`${css.betCardTitle} d-flex align-items-center headings`}
//           >
//             <span className="ml-auto mr-3"></span>
//           </div>
//         </div>
//         <div className="py-1 row battle_card_inner_bottom runing-padding">
//           <div className="pr-3 text-center col-5" style={{marginLeft:"-37px"}}>
          
//             <div className="">
//               <span className={css.betCardSubTitle} style={{styles}}>
//                 {translations[language].entry}
//               </span>
//               <div className="d-flex align-items-center justify-content-center">
//                 <img
//                   className="mx-1"
//                   src="/images/moneyrupee.png"
//                   alt=""
//                   width="18x"
//                   height="18x"
//                 />
//                 <span className={css.betCardAmount} style={{color:"#4aaa4d", fontSize:'24px', marginLeft:"2px"}}>{runnig.Game_Ammount}</span>
//               </div>
//             </div>
//           </div>
//           <div className="pr-3 text-center col-2 cxy" style={{top:"10px"}}>
//             <div>
//               {user == runnig.Accepetd_By._id ||
//               user == runnig.Created_by._id ? (
//                 <Link
//                   className={`${css.bgSecondary} ${css.playButton} ${
//                     css.cxy
//                   } position-relative m-2 mx-1 ${
//                     runnig.Status == "conflict" ? "bg-danger" : "bg-success"
//                   }`}
//                   style={{
//                     right: "0px",
//                     top: "-6px",
//                     padding: "10px 17px",
//                   }}
//                   to={{
//                     pathname: `/viewgame1/${runnig._id}`,
//                     state: { prevPath: window.location.pathname },
//                   }}
//                 >
//                   {translations[language].view}
//                 </Link>
//               ) : (
//                 <img
//                   className="mx-1 verses mb-2"
//                   src={process.env.PUBLIC_URL + "/images/Homepage/versus.png"}
//                   alt=""
//                   width="25x"
//                   height="25x"
//                 />
//               )}
//             </div>
//           </div>
//           <div className="text-center col-5" style={{marginRight:"-20px"}}>
//             <div className="">
//               <span className={css.betCardSubTitle} style={{color:"black"}}>
//                 {translations[language].prize}
//               </span>
//               <div className="d-flex align-items-center justify-content-center">
//                 <img
//                   className="mx-1"
//                     src="/images/moneyrupee.png"
//                   alt=""
//                   width="18x"
//                   height="18x"
//                 />
//                 <span className={css.betCardAmount} style={{color:"#4aaa4d", fontSize:'24px',}}>
//                   {runnig.Game_Ammount + winnAmount(runnig.Game_Ammount)}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }


import React, { useContext } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");

  // language
  const translations = {
    hi: {
      view: "देखे",
      prize: "Prize",
      entry: "Playing For",
    },
    en: {
      view: "view",
      entry: "Playing For",
      prize: "Prize",
    },
  };

  const { language } = useContext(LanguageContext);
  const theme = localStorage.getItem('theme');

  const styles = {
    color: theme === "light" ? "black" : "black",
  };

  return (
    <>
      <div
        className={`${css.betCard} mt-2 battle_card_main card_bottom_border running-card-box`}
        style={{
          backgroundImage: `url('/images/runningbetbg.avif')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '12px',
          overflow: 'hidden',
          marginBottom: '12px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}
      >
        {/* Top Header Row: Playing For & Prize */}
        <div className="d-flex justify-content-between align-items-center px-3 py-2" style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)', borderBottom: '1px solid rgba(255, 255, 255, 0.15)' }}>
          <div className="d-flex align-items-center gap-1">
            <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Playing For</span>
            <span style={{ fontSize: '14px', fontWeight: '800', color: '#4ade80', marginLeft: '4px' }}>₹ {runnig.Game_Ammount}</span>
          </div>

          <div className="d-flex align-items-center gap-1">
            <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Prize</span>
            <span style={{ fontSize: '14px', fontWeight: '800', color: '#4ade80', marginLeft: '4px' }}>₹ {runnig.Game_Ammount + winnAmount(runnig.Game_Ammount)}</span>
          </div>
        </div>

        {/* Bottom Players vs VS Section */}
        <div className="d-flex align-items-center justify-content-between px-3 py-2">
          
          {/* Creator Details with Avatar6 */}
          <div className="d-flex flex-column align-items-center" style={{ width: '35%' }}>
            <img
              src="/images/avatars/Avatar6.png"
              alt="Creator"
              style={{ width: '30px', height: '30px', borderRadius: '50%', objectFit: 'cover', marginBottom: '2px', border: '1px solid #ffffff' }}
            />
            <span style={{ fontSize: '13px', fontWeight: '700', color: '#ffffff', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
              {runnig.Created_by.Name.length > 8 ? `${runnig.Created_by.Name.slice(0, 8)}...` : runnig.Created_by.Name}
            </span>
          </div>

          {/* VS & View Button Center */}
          <div className="d-flex flex-column align-items-center justify-content-center" style={{ width: '30%' }}>
            {user == runnig.Accepetd_By._id || user == runnig.Created_by._id ? (
              <Link
                className={`btn btn-sm ${runnig.Status == "conflict" ? "btn-danger" : "btn-success"}`}
                style={{ fontSize: '12px', fontWeight: '700', padding: '4px 14px', borderRadius: '6px' }}
                to={{
                  pathname: `/viewgame1/${runnig._id}`,
                  state: { prevPath: window.location.pathname },
                }}
              >
                {translations[language].view}
              </Link>
            ) : (
              // <span style={{ fontSize: '18px', fontWeight: '900', fontStyle: 'italic', color: '#ef4444', letterSpacing: '1px' }}>
              //   VS
              // </span>
              <img
  src="/images/versers-2.png"
  alt="VS"
  style={{
    width: "35px",
    height: "35px",
    objectFit: "contain",
    display: "block",
  }}
/>
            )}
          </div>

          {/* Acceptor Details with Avatar7 */}
          <div className="d-flex flex-column align-items-center" style={{ width: '35%' }}>
            <img
              src="/images/avatars/Avatar7.png"
              alt="Acceptor"
              style={{ width: '30px', height: '30px', borderRadius: '50%', objectFit: 'cover', marginBottom: '2px', border: '1px solid #ffffff' }}
            />
            <span style={{ fontSize: '13px', fontWeight: '700', color: '#ffffff', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
              {runnig.Accepetd_By?.Name ? (runnig.Accepetd_By.Name.length > 8 ? `${runnig.Accepetd_By.Name.slice(0, 8)}...` : runnig.Accepetd_By.Name) : "Player"}
            </span>
          </div>

        </div>
      </div>
    </>
  );
}